import PropTypes from 'prop-types';
import React from 'react';
import BaseComponent from "../../../base-component/base-component";

import Classes from 'classnames'

class MentionOptionsEntry extends BaseComponent {

    constructor(props) {
        super(props);
    }

    renderIcon() {
        const { mention } = this.props;
        let res;
        switch (mention.id) {
            case gd.const.editorLink.type.TASK: res = <div className="option-icon i5-task"> </div>; break;
            case gd.const.editorLink.type.NOTE: res = <div className="option-icon i5-sticky-note"> </div>; break;
            case gd.const.editorLink.type.USER: res = <div className="option-icon i5-mention"> </div>; break;
            case gd.const.editorLink.type.LINK: res = <div className="option-icon editor-i5-link"> </div>; break;
        }
        return res;
    }

    render() {
        const {
            mention,
            theme,
            searchValue, // eslint-disable-line no-unused-vars
            isFocused, // eslint-disable-line no-unused-vars
            id, onMouseDown, onMouseEnter, onMouseUp, role, className
        } = this.props;

        const classes = Classes("mentions-options-entry", {
            isFocused: isFocused
        });

        return (
            <div aria-selected={this.props['aria-selected']}
                 id={id}
                 onMouseDown={onMouseDown}
                 onMouseEnter={onMouseEnter}
                 onMouseUp={onMouseUp}
                 role={role}
                 className={classes}>
                {this.renderIcon()}
                {mention.label}
            </div>
        );
    }
}

module.exports = MentionOptionsEntry;